import styled from "styled-components";

export const PageContainer = styled.div`
    min-height: inherit;
    background-color: var(--${(props) => props.bgcolor});
`